module.exports = __webpack_public_path__ + "static/img/1.13984813.jpg";